
































































































































































import { GeekItem } from '@/models';
import { dateRange, GeeksWithdrawal, ExportWithdrawalsFilters } from '@/models/admin-panel';
import { buildGeekName, download, ToastsService } from '@/utils';
import { collapseMixin, isWithdrawalsCollapseVisible } from '@/shared';
import { typedStore, Actions } from '@/store';
import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import Multiselect from 'vue-multiselect';

export default mixins(collapseMixin).extend({
  name: 'ExportWithdrawalsTab',
  components: {
    Multiselect,
  },
  data() {
    return {
      filters: {
        immediate: {
          dateRange: dateRange.ThisMonth,
        } as ExportWithdrawalsFilters,
      },
      loader: {
        isWithdrawalsToExportListPending: false,
      },
    };
  },
  computed: {
    collapsibleItems(): GeeksWithdrawal[] {
      return typedStore(this).state.gCoins.withdrawalsToExport;
    },
    areMoreItemsAvailable(): boolean {
      return this.collapsibleItems.length < typedStore(this).state.gCoins.pagination.totalCount
        && this.collapsibleItems.length > 0;
    },
    dateRangesToSelect(): dateRange[] {
      return Object.values(dateRange).filter(e => e !== this.filters.immediate.dateRange);
    },
  },
  methods: {
    async fetchWithdrawalsToExport() {
      this.loader.isWithdrawalsToExportListPending = true;
      try {
        await this.$store.dispatch(Actions.gCoins.fetchWithdrawalsToExport, this.filters.immediate);
      } finally {
        this.loader.isWithdrawalsToExportListPending = false;
      }
    },
    async fetchMore() {
      this.loader.isWithdrawalsToExportListPending = true;
      try {
        await this.$store.dispatch(Actions.gCoins.fetchMoreWithdrawalsToExport, this.filters.immediate);
      } finally {
        this.loader.isWithdrawalsToExportListPending = false;
      }
    },
    async fetchWithdrawals() {
      const fileContent = await this.$store.dispatch(Actions.gCoins.fetchWithdrawals, this.filters.immediate);
      download(
        'LoG-geeks_withdrawals_report.xlsx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet/xlsx',
        fileContent,
      );
      ToastsService.success(this.$t('admin-panel.gcoins.labels.download-report-success') as string);
    },
    isWithdrawalsCollapseVisible,
    buildGeekName,
  },
  watch: {
    'filters.immediate': {
      handler(this: any) {
        this.fetchWithdrawalsToExport();
      },
      deep: true,
      immediate: true,
    },
  },
});
